import React, { FC } from 'react';
import { useTranslation } from '@jobcost-monorepo/i18n';
import { Button } from '@jobcost-monorepo/ui';
import { useFormContext } from 'react-hook-form';
import dayjs from '@jobcost-monorepo/dayjs-config';
import { useListContext } from '../../../common';
import { OrderStateEnum } from '@jobcost-monorepo/database/prisma/enums';

const CreateOrderDuplicateButton: FC = () => {
  const { t } = useTranslation('orders');
  const { setFormElement, formElement } = useListContext();
  const { setValue, watch } = useFormContext();
  const id = watch('id');
  const endDate = watch('endDate');

  const renewOrder = () => {
    setValue('id', undefined);
    const startDate = dayjs.utc(endDate).add(1, 'days').format('YYYY-MM-DD');
    setValue('startDate', startDate);
    setValue('endDate', null);
    setValue('orderState', OrderStateEnum.Running);
    const duplicateFormElement = {
      ...formElement,
      id: undefined,
      startDate,
      endDate: null,
      orderState: OrderStateEnum.Running,
    };
    setFormElement(duplicateFormElement);
  };

  return id ? (
    <div className="flex flex-col justify-center align-middle space-x-4">
      <Button type="button" onClick={renewOrder} disabled={false}>
        {t('form.createOrderDuplicateButton')}
      </Button>
    </div>
  ) : (
    <div />
  );
};

export default CreateOrderDuplicateButton;
